export const MAX_CHARACTERS_FOR_CAMPAIGNS_NAME = 45;

const TARGET_CPA = 'Target CPA';

export const MANUAL_STRATEGY_TYPE = {
    cpm: 'Manual CPM',
    cpv: 'Manual CPV',
    cpc: 'Manual CPC',
};

export const TARGET_STRATEGY_TYPE = {
    [TARGET_CPA]: TARGET_CPA,
};

export const MULTIPLE_STRATEGIES = 'Multiple Strategies';

export const TARGET_IMPRESSION_SHARE = 'Target Impression Share';

export const SEGMENTS_MODAL_TEXTS = {
    button: 'TagsGroup',
    label: '',
    createLabel: 'Add Tags',
    saveLabel: 'Save Tags',
    headerLabel: 'Unify data from your Google/Facebook campaigns on categories to have an integrated monitoring view of data, thus having a more strategic view of performance.',
    gaugeLabel: 'Campaigns Tagged ',
    tagsPlaceHolder: 'Edit here...',
    inputNameGroupPlaceholder: 'Type here the group name...',
};
